import React from 'react'

const Loader = () => {
  return (
    <div className='text_loader'></div> 
  )
}

export default Loader
